import axios from '../axios';
import { ONLOAD_INFORMATION_API, GET_ORDER_STATUS, URL_VALIDATION_API } from '../../global/ApiUrl';

// Hedaer is added just for testing to capture header getting with this API,we can also pass header with mob header extention
export const onLoadInformationAPI = async (payload) => {
  try {
    const response = await axios.post(ONLOAD_INFORMATION_API, payload, {
      headers: {
        syed: 'syed',
      },
    });
    return response;
  } catch (error) {
    console.log('onLoadInformationAPI  catch block', error);
    return { success: false, error };
  }
};

export const UrlValidationAPI = async (payload) => {
  try {
    const response = await axios.post(URL_VALIDATION_API, payload, {
      headers: {
        syed: 'syed',
      },
    });
    return response;
  } catch (error) {
    console.log('UrlValidationAPI  catch block', error);
    return { success: false, error };
  }
};

export const GetOrderStatusAPI = async (payload) => {
  try {
    const response = await axios.post(GET_ORDER_STATUS, payload);
    return response;
  } catch (error) {
    await console.log('catch error in GetOrderStatusAPI', error);
    return { success: false, error };
  }
};
